// Import model
import { StartIndividualContactAddNoteRequest } from '../models/StartIndividualContactAddNoteRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartIndividualContactAddNoteRequest - handles JSON serialization and deserialization with type validation
 */
export class StartIndividualContactAddNoteRequestSerializer {
  /**
   * Deserializes a JSON string into a StartIndividualContactAddNoteRequest instance
   */
  static deserialize(json: string): StartIndividualContactAddNoteRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartIndividualContactAddNoteRequest instance
   */
  static fromObject(obj: any): StartIndividualContactAddNoteRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartIndividualContactAddNoteRequest');
    }


    const instance: StartIndividualContactAddNoteRequest = {
      content: obj['Content'] as string | undefined,
      name: obj['Name'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartIndividualContactAddNoteRequest instances
   */
  static deserializeArray(json: string): StartIndividualContactAddNoteRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartIndividualContactAddNoteRequest instance to a JSON string
   */
  static serialize(instance: StartIndividualContactAddNoteRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartIndividualContactAddNoteRequest instance to a plain object
   */
  static toObject(instance: StartIndividualContactAddNoteRequest): any {
    return {
      'Content': instance.content,
      'Name': instance.name,
    };
  }

  /**
   * Serializes an array of StartIndividualContactAddNoteRequest instances to a JSON string
   */
  static serializeArray(instances: StartIndividualContactAddNoteRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
